import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IconButtonComponent } from './icon-button.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [IconButtonComponent],
  declarations: [IconButtonComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class IconButtonComponentModule {}
